import { authOptions } from '@/app/api/auth/[...nextauth]/route';
import { deleteCookie, setCookie } from 'cookies-next';
import { getServerSession } from 'next-auth';
import { signIn } from 'next-auth/react';
import { redirect } from 'next/navigation';
// import { decodeJwt } from '../global';
import { clearPersistedStores } from '@/utils/storage/indexeddb-storage';
import { toast } from 'sonner';
import { event_login, event_user_auth } from '../gtm';
import { manageCartAfterLogin } from '../cart/manage-cart-after-login';
// session and handshake in server side
// const session = await getServerSessionData();
// const handshake = (await cookies()).get('handshake')?.value;

// session and handshake in client side
// const { data: session, status } = useSession();
// const handshake = getCookie('handshake');

export const getServerSessionData = async ({
  allowRedirection = true,
  redirectionLink = '/',
} = {}) => {
  const session = await getServerSession(authOptions);

  if (!session && allowRedirection) {
    redirect(redirectionLink);
  }

  return session;
};

export const signOutHandler = async (setIsOldUser, user = {}) => {
  // await signOut({ callbackUrl: '/' });
  event_user_auth(user, 'user_logout_event', 'Logout');
  await clearPersistedStores(['cart', 'checkout', 'shipping-info']);
  deleteCookie('quote');
  deleteCookie('mage');
  deleteCookie('isPharmacist');
  deleteCookie('adminId');
  event_user_auth('user_logout_event', 'Logout');
  setIsOldUser(false);
};

export const signInHandler = async ({
  response,
  rememberMe,
  locale,
  clearCheckout,
  setActiveShippingMethod,
  loginType,
  callbackUrl,
  replace,
  session,
  update,
  setIsModalOpen,
  isSalesLogin = false,
  isPharmacist = false,
  adminId,
}) => {
  const token = response?.data?.token;

  // const decodedToken = decodeJwt(token, false);
  // const expires = new Date(decodedToken.exp * 1000);

  // setCookie('mage', token, { expires });
  setCookie('mage', token, { maxAge: 1 * 24 * 60 * 60 });
  setCookie('isPharmacist', isPharmacist, { maxAge: 1 * 24 * 60 * 60 });
  if (adminId) {
    setCookie('adminId', adminId, { maxAge: 1 * 24 * 60 * 60 });
  }

  const lastUrl = sessionStorage.getItem('loginRedirect');

  const user = {
    id: response?.data?.user?.id,
    store_id: response?.data?.user?.store_id,
    email: response?.data?.user?.email,
    firstname: response?.data?.user?.firstname || '',
    lastname: response?.data?.user?.lastname || '',
    mobilenumber: response?.data?.user?.custom_attributes?.find(
      (attr) => attr.attribute_code === 'mobilenumber'
    )?.value,
    is_rabah_customer: response?.data?.user?.custom_attributes?.find(
      (attr) => attr.attribute_code === 'is_rabah_customer'
    )?.value,
    rememberMe,
    created_at: response?.data?.user?.created_at,
    is_sales_login: isSalesLogin,
    is_pharmacist: isPharmacist,
    ...(adminId ? { adminId } : {}),
  };

  // Fire GTM events BEFORE signIn/update to ensure they trigger
  if (user) {
    event_login({
      user: { ...response?.data?.user, ...user },
      method: loginType,
      status: 'Success',
      referral_url: lastUrl || callbackUrl,
    });
  }

  // Always use redirect: false to maintain control over navigation
  const res = !session?.user?.id
    ? await signIn('credentials', {
      token,
      user: JSON.stringify(user),
      callbackUrl: callbackUrl ? callbackUrl : `/`,
      redirect: false, // Changed to false to prevent automatic redirect
    })
    : await update({
      token,
      user: JSON.stringify(user),
    });

  if (!res.ok && res.status !== 200) {
    toast.error(
      locale === 'en'
        ? 'Mobile number or OTP is wrong, please try again'
        : 'خطأ فى الرقم الموبايل او الكود المرسل'
    );
  } else {
    clearCheckout ? clearCheckout() : null;
    setActiveShippingMethod ? setActiveShippingMethod(null) : null;

    setIsModalOpen?.(true);

    // Wait a brief moment for GTM events to fire before redirecting
    await new Promise(resolve => setTimeout(resolve, 100));
    await manageCartAfterLogin(isSalesLogin)
    // Manual redirect after events have fired
    if (lastUrl) {
      sessionStorage.removeItem('loginRedirect');
      replace(lastUrl);
    } else if (callbackUrl) {
      replace(callbackUrl);
    } else {
      replace(`/${locale}`);
    }
  }
};